// extracted by mini-css-extract-plugin
export default {"linhaSalvar":"ModalCadastro_linhaSalvar__s-yxI","alerta":"ModalCadastro_alerta__54YsY"};